import { connect } from 'react-redux'
import SamplesHoverInteraction from '../../components/olComponents/interaction/SamplesHoverInteraction'
import { getSelectedSample } from '../../selectors/samples'

const mapStateToProps = state => ({
  selectedSample: getSelectedSample(state)
})

export default connect(mapStateToProps)(SamplesHoverInteraction)
